if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        
        if (this.elements.viewer) {
          this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        }
        if (this.elements.thumbnails) {
          this.elements.thumbnails.querySelectorAll('[data-target], [data-media-id]').forEach((mediaToSwitch) => {
            const btn = mediaToSwitch.querySelector('button') || (mediaToSwitch.tagName === 'BUTTON' ? mediaToSwitch : None);
            const targetId = mediaToSwitch.dataset.target || mediaToSwitch.dataset.mediaId;
            if (btn && targetId) {
              btn.addEventListener('click', (e) => {
                this.setActiveMedia(targetId, false);
              });
            }
          });
          if (this.dataset.desktopLayout && this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) {
            this.removeListSemantic();
          }
        }
      }

      onSlideChanged(event) {
        if (!this.elements.thumbnails || !event.detail || !event.detail.currentElement) return;
        const mediaId = event.detail.currentElement.dataset.mediaId;
        const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"], [data-media-id="${mediaId}"]`);
        if (thumbnail) this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        if (!this.elements.viewer) return;

        // Try exact match or match ending with mediaId
        let activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia && mediaId.includes('-')) {
          const rawId = mediaId.split('-').pop();
          activeMedia = this.elements.viewer.querySelector(`[data-media-id$="${rawId}"]`);
        }
        if (!activeMedia) {
          activeMedia = this.elements.viewer.querySelector('[data-media-id]');
        }
        if (!activeMedia) return;

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend && activeMedia.parentElement) {
          activeMedia.parentElement.prepend(activeMedia);
          if (activeMedia.parentElement.scrollTo) activeMedia.parentElement.scrollTo({ left: 0, top: 0 });
        }

        if (this.elements.thumbnails) {
          let activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"], [data-media-id="${mediaId}"]`);
          if (!activeThumbnail && mediaId.includes('-')) {
            const rawId = mediaId.split('-').pop();
            activeThumbnail = this.elements.thumbnails.querySelector(`[data-target$="${rawId}"], [data-media-id$="${rawId}"]`);
          }
          if (activeThumbnail) {
            if (prepend && activeThumbnail.parentElement) {
              activeThumbnail.parentElement.prepend(activeThumbnail);
              if (activeThumbnail.parentElement.scrollTo) activeThumbnail.parentElement.scrollTo({ left: 0, top: 0 });
            }
            this.setActiveThumbnail(activeThumbnail);
          }
        }

        if (this.elements.viewer.slider) {
          if (this.elements.viewer.slider.scrollTo) this.elements.viewer.slider.scrollTo({ left: 0, top: 0 });
          if (this.elements.viewer.resetPages) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.viewer && this.elements.viewer.slider && this.elements.viewer.slider.scrollTo) {
            this.elements.viewer.slider.scrollTo({ left: 0, top: 0 });
          }
          if (activeMedia.parentElement && activeMedia.parentElement.scrollTo) {
            activeMedia.parentElement.scrollTo({ left: 0, top: 0 });
          }
        });
        this.playActiveMedia(activeMedia);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        
        const btn = thumbnail.querySelector('button') || (thumbnail.tagName === 'BUTTON' ? thumbnail : null);
        if (btn) btn.setAttribute('aria-current', 'true');

        if (this.elements.thumbnails.isSlideVisible && this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        if (this.elements.thumbnails.slider && thumbnail.offsetLeft !== undefined) {
          this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft, top: thumbnail.offsetTop });
        }
      }

      announceLiveRegion(activeItem, position) {
        if (!this.elements.liveRegion) return;
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          if (window.accessibilityStrings && window.accessibilityStrings.imageAvailable) {
            this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          }
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        if (window.pauseAllMedia) window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia && deferredMedia.loadContent) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer || !this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        if (this.elements.viewer.sliderItems) {
          this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
        }
      }
    }
  );
}
